module.exports = __webpack_public_path__ + "img/banner_8.44afe2c3.png";